// extracted by mini-css-extract-plugin
module.exports = {"total":"style_total__1qnUG","num":"style_num__Gzn_6","unit":"style_unit__ZSCU1","addForm":"style_addForm__2VGrA","cell":"style_cell__3YLWw","priceInput":"style_priceInput__3OBet"};